import { NAV_LINKS } from '../data';

export default function Nav() {
  return (
    <nav className="lw-nav">
      <a className="lw-nav__logo" href="#top">LittleWins</a>
      <div className="lw-nav__links">
        {NAV_LINKS.map((l) => (
          <a key={l.href} href={l.href}>{l.label}</a>
        ))}
      </div>
    </nav>
  );
}
